export default __webpack_public_path__ + "static/media/LAVATÓRIO P.MÃOS DIVERSOS.055f8c17.png";